import { IRootScopeService } from 'angular';
import { ItemsPaginator } from '../../tn.common';

export class FontPaginationService extends ItemsPaginator {
    static $inject = ['$rootScope'];
    constructor($rootScope: IRootScopeService) {
        super($rootScope);
    }
}
